<template>
    <uv-popup
        :z-index="zIndex"
        :overlayStyle="{ background: overlayStyle }"
        :bgColor="bgColor"
        ref="$refModal"
        :closeOnClickOverlay="closeOnClickOverlay"
        @maskClick="cancle"
        @close="closeModal"
        :mode="mode"
        :zoom="false"
        :round="round"
        :safeAreaInsetBottom="safeAreaInsetBottom"
        :duration="duration"
    >
        <slot></slot>
    </uv-popup>
</template>

<script setup>
    import { onMounted, ref } from 'vue';

    const $refModal = ref(null);
    const $props = defineProps({
        zIndex: {
            type: String,
            default: '999'
        },
        duration: {
            type: Number,
            default: 100
        },
        overlayStyle: {
            type: String,
            default: 'rgba(0, 0, 0, 0.2)'
        },
        closeOnClickOverlay: {
            type: Boolean,
            default: true
        },
        mode: {
            type: String,
            default: 'center'
        },
        bgColor: {
            type: String,
            default: '#F5F3ED'
        },

        safeAreaInsetBottom: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ''
        },
        callBackFun: {
            type: Function
        },
        round: {
            type: String,
            default: '20px'
        }
    });
    onMounted(() => {
        $refModal.value.open();
    });

    const $emits = defineEmits(['confirm', 'close', 'cancel']);
    const openModal = () => {
        $refModal.value.open();
    };
    const closeModal = () => {
        $refModal.value.close();
        $emits('close', false);
    };
    const cancle = () => {
        if (!$props.closeOnClickOverlay) {
            return;
        }
        closeModal();
    };

    defineExpose({
        closeModal,
        openModal
    });
</script>

<style lang="scss" scoped>
    .titles {
        font-size: 20px;
        color: #4f5767;
        font-weight: 600;
    }

    .btn {
        display: inline-flex;
        justify-content: space-around;
        padding-bottom: 25px;

        text {
            line-height: 35px;
            height: 35px;
            padding: 0 35px;
            border-radius: 35px;
            color: #fff;
        }

        .cancle {
            background: #c9c9c9;
        }

        .chat {
            background: $btn-color;
        }
    }
</style>
